// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/icon.css'
import './components/common/directives'
import 'babel-polyfill'
import { getToken } from '@/utils/auth' // get token from cookie
import { installAccessCapabilities } from '@/directives/access'
import { createAuthenticatedNavigation, accessRecoveryLocation, ACCESS_RECOVERY_PATH } from '@/router/authenticated-navigation'
import { installClientDiagnostics, recordClientEvent } from '@/utils/client-diagnostics'

import VueClipboard from 'vue-clipboard2'

import plTable from 'pl-table'
import 'pl-table/themes/index.css'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

const authenticateNavigation = createAuthenticatedNavigation(store, router, getToken)
let pendingNavigation = '/home'

Vue.use(plTable)

Vue.config.productionTip = false
installClientDiagnostics(Vue)
Vue.use(ElementUI, {
  size: 'small'
})
Vue.use(Vuex)
installAccessCapabilities(Vue, store)

router.beforeEach((to, from, next) => {
  pendingNavigation = to.fullPath || to.path
  let systemName = '系统管理'
  let faviconName = 'static/qinglee.ico'
  if (window.location.host === 'erp.qinglee.com') {
    systemName = '轻雷科技'
    faviconName = 'static/qinglee.ico'
  } else if (window.location.host === 'db.wgcang.com') {
    systemName = '万国仓'
    faviconName = 'static/wgcang.ico'
  } else if (window.location.host === 'xinsitu.qinglee.com') {
    systemName = '鑫思途ERP'
    faviconName = 'static/xinsitu.ico'
  } else if (window.location.host === 'erp.huayutong56.com') {
    systemName = '华羽通ERP'
    faviconName = 'static/huayutong.ico'
  }

  document.title = systemName
  addFavicon(faviconName)

  return authenticateNavigation(to, from, next)
})

router.onError(error => {
  recordClientEvent('route_error', error || {})
  if (router.currentRoute.path === ACCESS_RECOVERY_PATH) return
  const navigation = router.replace(accessRecoveryLocation(pendingNavigation))
  if (navigation && navigation.catch) navigation.catch(() => {})
})

const addFavicon = link => {
  var favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
  favicon.type = 'image/x-icon'
  favicon.rel = 'icon'
  favicon.href = link
  document.head.appendChild(favicon)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js